<div class="saldo-card">
  <div class="saldo-head" [class.clickable]="impagos.length" (click)="impagos.length && (expandido = !expandido)">
    <div class="saldo-icon">
      <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><line x1="12" y1="1" x2="12" y2="23"/><path d="M17 5H9.5a3.5 3.5 0 0 0 0 7h5a3.5 3.5 0 0 1 0 7H6"/></svg>
    </div>
    <div class="saldo-info">
      <div class="saldo-label">Saldo por cobrar — pedidos entregados</div>
      <div class="saldo-value">{{ formatShort(totalPorCobrar) }}</div>
      <div class="saldo-sub">{{ cantidad }} pedidos · {{ formatMoney(totalKg) }} Kg</div>
    </div>
    <button type="button" class="saldo-toggle" *ngIf="impagos.length" [attr.aria-expanded]="expandido">
      <span>{{ expandido ? 'Ocultar' : 'Ver detalle' }}</span>
      <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" [class.rot]="expandido"><polyline points="6 9 12 15 18 9"/></svg>
    </button>
  </div>

  <div class="saldo-list" *ngIf="impagos.length && expandido">
    <div class="saldo-item" *ngFor="let o of impagos">
      <div class="saldo-item-main">
        <div class="saldo-item-top">
          <span class="saldo-id">#{{ o.idMadre }}</span>
          <span class="saldo-cliente">{{ o.cliente || 'Sin nombre' }}</span>
        </div>
        <span class="saldo-email" *ngIf="o.contactEmail">{{ o.contactEmail }}</span>
        <div class="saldo-fechas">
          <span *ngIf="o.fecha">Pedido {{ o.fecha | date:'dd/MM/yy' }}</span>
          <span *ngIf="o.fechaEntrega">· Entregado {{ o.fechaEntrega | date:'dd/MM/yy' }}</span>
        </div>
      </div>
      <div class="saldo-item-vals">
        <span class="saldo-monto">{{ formatShort(o.total) }}</span>
        <span class="saldo-kg">{{ formatMoney(o.totalKg) }} Kg</span>
      </div>
    </div>
  </div>

  <div class="saldo-empty" *ngIf="!impagos.length">Sin pedidos pendientes de cobro.</div>
</div>
